module.exports = __webpack_public_path__ + "img/banner.17c97af1.png";